import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-scroll'

import styles from './styles.scss'

const ScrollLink = (props) => {
  const {
    containerId,
    to,
    label
  } = props

  return (
    <Link
      activeClass={styles.activeLink}
      className={styles.link}
      containerId={containerId}
      to={to}
      spy={true}
      smooth={true}
      duration={500}>
      {label}
    </Link>
  )
}

ScrollLink.propTypes = {
  containerId: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
}

export default ScrollLink
